let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e376P")).then(() => parcelRequire('iYtFP'));